export default __webpack_public_path__ + "static/media/employees-icon.1415de5f.svg";